export default "__VITE_ASSET__WyH7hfkD__"